// ── Zana za Wiki ────────────────────────────────────────────────────────
// Ripoti binafsi ni MOJA kwa mtu kwa wiki. Tunatumia ISO week key
// (mf. "2026-W32") ili staff wote waone wiki ileile bila mkanganyiko.

export function isoWeekKey(date = new Date()) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
  return `${d.getUTCFullYear()}-W${String(weekNo).padStart(2, '0')}`;
}

// Jumatatu ya wiki husika
export function weekStart(date = new Date()) {
  const d = new Date(date);
  const day = d.getDay() || 7;
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() - day + 1);
  return d;
}

export function weekEnd(date = new Date()) {
  const d = weekStart(date);
  d.setDate(d.getDate() + 6);
  d.setHours(23, 59, 59, 999);
  return d;
}

const MONTHS_SW = ['Jan', 'Feb', 'Mac', 'Apr', 'Mei', 'Jun', 'Jul', 'Ago', 'Sep', 'Okt', 'Nov', 'Des'];

export function weekLabel(date = new Date()) {
  const s = weekStart(date);
  const e = weekEnd(date);
  return `${s.getDate()} ${MONTHS_SW[s.getMonth()]} – ${e.getDate()} ${MONTHS_SW[e.getMonth()]} ${e.getFullYear()}`;
}

export function shiftWeeks(date, n) {
  const d = new Date(date);
  d.setDate(d.getDate() + n * 7);
  return d;
}

// Siku ngapi zimebaki kabla wiki haijaisha (kwa reminder)
export function daysLeftInWeek(date = new Date()) {
  return Math.max(0, Math.ceil((weekEnd(date) - date) / 86400000));
}

export function fmtDate(ts) {
  if (!ts) return '—';
  const d = ts?.toDate ? ts.toDate() : new Date(ts);
  if (isNaN(d)) return '—';
  return `${d.getDate()} ${MONTHS_SW[d.getMonth()]} ${d.getFullYear()}`;
}

export function fmtDateTime(ts) {
  if (!ts) return '—';
  const d = ts?.toDate ? ts.toDate() : new Date(ts);
  if (isNaN(d)) return '—';
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${fmtDate(d)}, ${hh}:${mm}`;
}

// Rudisha tarehe (Jumatatu) ya wiki kutokana na ufunguo kama "2026-W32"
export function weekKeyToDate(key) {
  if (!key || !/^\d{4}-W\d{2}$/.test(key)) return new Date();
  const [y, w] = key.split('-W').map(Number);
  const jan4 = new Date(y, 0, 4);
  const jan4Day = jan4.getDay() || 7;
  const week1Monday = new Date(jan4);
  week1Monday.setDate(jan4.getDate() - jan4Day + 1);
  const d = new Date(week1Monday);
  d.setDate(week1Monday.getDate() + (w - 1) * 7);
  return d;
}
